import type { VariantProps } from "class-variance-authority"
import { cva } from "class-variance-authority"

export { default as Badge } from "./Badge.vue"

export const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    // Cut onto the semantic tokens: the stock shadcn classes (bg-secondary,
    // *-foreground, …) resolve to NOTHING while the shadcn @theme block is
    // commented out — badges rendered as bare text (ITDEVELOP-1450 QA). And
    // bg-primary is a false friend: the atNorth app-background token.
    variants: {
      variant: {
        default:
          "border-transparent bg-[var(--btn-primary-bg)] text-[var(--text-on-accent)] shadow hover:brightness-95",
        secondary:
          "border-transparent bg-[var(--tag-primary)] text-[var(--text-primary)] hover:brightness-95",
        destructive:
          "border-transparent bg-[var(--state-danger-bg)] text-[var(--state-danger-fg)] shadow hover:brightness-95",
        outline: "text-primary",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
)

export type BadgeVariants = VariantProps<typeof badgeVariants>
